import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useWindowResizeEvent } from '@wix/da-hooks/pkg/useWindowResizeEvent';
import { DeviationViewContext } from '../Context';
import DeviationPageContent from './_partials/DeviationPageContent';
import SiteFooter from '../SiteFooter';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
import { useFullscreenEvents } from '../utils/hooks/useFullscreenEvents';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useDuperbrowseViewType } from '../Duperbrowse/DuperbrowseViewContext';
import { SubscriptionPurchaseFTUEContextProvider } from '../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { getBiEventComponentByType, getPageTitle, getDeviationAppUrl, } from './redux/helpers';
import { getDeviationType, getDeviationResourceType, } from '../DeviationViews/_helpers';
import Notifications from '../Notifications';
import { useDeviationChangedCallback } from './hooks/useDeviationChangedCallback';
import DeviationPageHeader from './_partials/DeviationPageHeader';
import DeviationPageLoader from './_partials/DeviationPageLoader';
import { MatureDeviationContextProvider } from '../Context/MatureDeviationContext';
import DaAppUrl from '../DaApp/DaAppUrl';
import s from './DeviationPage.scss';
var DeviationPage = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, onLoad = _a.onLoad, viewMode = _a.viewMode, onFullscreenEntered = _a.onFullscreenEntered, onFullscreenExited = _a.onFullscreenExited, onScreenResize = _a.onScreenResize;
    var t = useTranslation().t;
    var isInDuperbrowse = useDuperbrowseViewType().isInDuperbrowse;
    useFullscreenEvents({
        onFullscreenEntered: function () { return deviation && onFullscreenEntered(deviation); },
        onFullscreenExited: function () { return deviation && onFullscreenExited(deviation); },
    });
    useWindowResizeEvent(onScreenResize);
    useDeviationChangedCallback(deviation, onLoad);
    useEffect(function () {
        onScreenResize(window.innerWidth, window.innerHeight);
    }, [onScreenResize]);
    var biComponent = getBiEventComponentByType(getDeviationType(deviation));
    var isFullscreen = viewMode === DeviationViewMode.Fullscreen;
    var showHeaderAndFooter = !isFullscreen;
    var appUrl = getDeviationAppUrl(deviation);
    return (React.createElement(DeviationViewContext.Provider, { value: viewMode },
        isInDuperbrowse && (React.createElement(Helmet, null,
            React.createElement("title", null, getPageTitle(deviation, t)))),
        appUrl && React.createElement(DaAppUrl, { url: appUrl }),
        React.createElement("main", { role: "main", className: classnames(s['root'], isFullscreen && s['fullscreen']) },
            showHeaderAndFooter && React.createElement(DeviationPageHeader, null),
            !deviation && React.createElement(DeviationPageLoader, null),
            deviation && (React.createElement(BiLoggerContextProvider, { value: {
                    view: 'submission',
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    creatorid: (_c = (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid) !== null && _c !== void 0 ? _c : '',
                    component: biComponent,
                    sectionname: 'deviation',
                } },
                React.createElement(MatureDeviationContextProvider, { deviation: deviation },
                    React.createElement(SubscriptionPurchaseFTUEContextProvider, { deviation: deviation },
                        React.createElement(DeviationPageContent, { deviation: deviation }))))),
            showHeaderAndFooter && React.createElement(SiteFooter, null)),
        React.createElement(Notifications, { wrapperClassName: classnames(viewMode === DeviationViewMode.Normal && s['stage-notifications']) })));
};
DeviationPage.displayName = 'DeviationPage';
export default DeviationPage;
//# sourceMappingURL=DeviationPage.js.map